
import React, { Dispatch, SetStateAction } from 'react';
import { PersonSearchPopup } from './PersonSearchPopup';
import { Person } from 'types';
import { MultipleFileUploadComponent } from 'components/form/MultipleFileUpload';

interface OwnerPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onFileChange: (file: File[] )=> void;

  onSearchPerson: (e: React.FormEvent) => void;
  onPersonSelect: (personId: string) => void;
  onUserSubmit: (data: any, isEditMode: boolean) => void;
  formData: any;
  pdfFile: File[];
  loading: boolean;
  error: string | null;
  searchFayda: string;
  setSearchFayda: (value: string) => void;
  searchPhone: string;
  setSearchPhone: (value: string) => void;
  searchedPersons: any[];
  selectedPerson: any;
  selectedPersonId: string;
  searchLoading: boolean;
  userFormLoading: boolean;
  isEditMode?: boolean; // Add edit mode flag
  existingData?: any; // Add existing owner data for edit
   setSelectedPerson?: Dispatch<SetStateAction<Person | null>>;
  setSelectedPersonId?: Dispatch<SetStateAction<string>>;
  setSearchedPersons?: Dispatch<SetStateAction<Person[]>>;
}

export const OwnerPopup: React.FC<OwnerPopupProps> = ({
  isOpen,
  onClose,
  onSubmit,
  onInputChange,
  onFileChange,

  onSearchPerson,
  onPersonSelect,
  onUserSubmit,
  formData,
  pdfFile,
  loading,
  error,
  searchFayda,
  setSearchFayda,
  searchPhone,
  setSearchPhone,
  searchedPersons,
  selectedPerson,
  selectedPersonId,
  searchLoading,
  userFormLoading,
  isEditMode = false,
  existingData,
  setSearchedPersons,
  setSelectedPerson,
  setSelectedPersonId
}) => {
  // const validateForm = () => {
  //   if (!isEditMode && !formData.ownership_proof) return "Ownership proof is required";
  //   return "";
  // };

  return (
    <PersonSearchPopup
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      onInputChange={onInputChange}
      onSearchPerson={onSearchPerson}
      onPersonSelect={onPersonSelect}
      onUserSubmit={onUserSubmit}
      formData={formData}
      loading={loading}
      error={error}
      searchFayda={searchFayda}
      setSearchFayda={setSearchFayda}
      searchPhone={searchPhone}
      setSearchPhone={setSearchPhone}
      searchedPersons={searchedPersons}
      selectedPerson={selectedPerson}
      selectedPersonId={selectedPersonId}
      searchLoading={searchLoading}
      userFormLoading={userFormLoading}
      title={isEditMode ? "Edit Owner" : "Add Owner"} // Dynamic title
      description={isEditMode ? "Edit owner information" : "Add owner information"}
      // validateForm={validateForm}
      isEditMode={isEditMode} 
      existingData={existingData} 
      setSearchedPersons={setSearchedPersons}
      setSelectedPerson={setSelectedPerson}
      setSelectedPersonId={setSelectedPersonId}
    >
      {/* Owner-specific form fields */}
    <MultipleFileUploadComponent 
    uploadedFiles={pdfFile}
    onFilesChange={onFileChange}
    label='Ownership proof'
    />

      <div className="flex flex-col mb-4">
        <label className="referral-popup-label">Property Description</label>
        <textarea
          onChange={onInputChange}
          name="property_description"
          placeholder="Property Description"
          className="referral-form-field h-24"
          value={formData.property_description}
        />
      </div>
    </PersonSearchPopup>
  );
};